export enum GameType {
  Unknown = 0,
  Single = 1,
  Match = 2,
}
